var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{staticClass:"tabs",attrs:{"show-arrows":"","background-color":"#00939B","dark":"","value":_vm.selectedIndex},on:{"change":_vm.onChange}},[_c('v-tabs-slider'),_vm._l((_vm.items),function(item,i){return _c('v-tab',{key:i},[_vm._v(" "+_vm._s(item)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }